import { render, staticRenderFns } from "./NavSublinked.vue?vue&type=template&id=101f8ec2"
import script from "./NavSublinked.vue?vue&type=script&lang=js"
export * from "./NavSublinked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavLink: require('/vercel/path0/components/Nav/NavLink.vue').default,BaseAccordion: require('/vercel/path0/components/Base/Accordion/BaseAccordion.vue').default})
